export default "__VITE_ASSET__HjV8FBrq__"